import { useState } from "react";
import { Play } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

const VIDEO_SRC = "/embrace-ad.mp4";
const POSTER_SRC = "/ad-poster.jpg";

export const VideoModal = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent
      data-testid="hero-video-modal"
      className="max-w-5xl w-[calc(100%-2rem)] p-0 bg-brand-ink border-0 overflow-hidden rounded-2xl"
    >
      <DialogTitle className="sr-only">Embrace Healthcare video</DialogTitle>
      {open && (
        <video
          data-testid="hero-video-player"
          src={VIDEO_SRC}
          poster={POSTER_SRC}
          controls
          autoPlay
          playsInline
          className="w-full aspect-video bg-black"
        />
      )}
    </DialogContent>
  </Dialog>
);

export const HeroVideoButton = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid="hero-video-play-button-mobile"
        className="md:hidden inline-flex items-center justify-center gap-2 rounded-full border border-white/40 bg-white/10 backdrop-blur-sm text-white px-7 py-4 text-base font-semibold hover:bg-white hover:text-brand-ink transition-all duration-300"
      >
        <Play className="w-4 h-4" fill="currentColor" /> Watch our video
      </button>
      <VideoModal open={open} onOpenChange={setOpen} />
    </>
  );
};

export const HeroVideoCard = () => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid="hero-video-play-button"
        aria-label="Watch our video"
        className="group hidden md:block absolute bottom-8 right-6 lg:right-10 w-[22rem] rounded-2xl overflow-hidden shadow-2xl border border-white/20 fade-up fade-up-delay-3 focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-blush"
      >
        <img src={POSTER_SRC} alt="Watch the Embrace Healthcare video" className="w-full aspect-video object-cover transition-transform duration-500 group-hover:scale-105" />
        <span className="absolute inset-0 bg-brand-ink/30 group-hover:bg-brand-ink/15 transition-colors duration-300" />
        <span className="absolute inset-0 flex items-center justify-center">
          <span className="w-16 h-16 rounded-full bg-white text-brand flex items-center justify-center shadow-lg transition-transform duration-300 group-hover:scale-110">
            <Play className="w-7 h-7 ml-1" fill="currentColor" />
          </span>
        </span>
        <span className="absolute left-3 top-3 inline-flex items-center gap-1.5 rounded-full bg-brand-ink/60 backdrop-blur-sm px-3 py-1.5 text-[10px] uppercase tracking-[0.18em] font-semibold text-white">
          <span className="w-1.5 h-1.5 rounded-full bg-brand-blush" /> Watch our video
        </span>
      </button>
      <VideoModal open={open} onOpenChange={setOpen} />
    </>
  );
};
